

class SolverProgressController {
    constructor($scope) {
        this._$scope = $scope;

        this.progressMapper = {
            part: {
                startPosition: 0,
                startLabel: 'Uploading Part',
                data: {
                    load: {
                        name:  'Uploading Part',
                        percent: 20
                    }, read: {
                        name:  'Sending request',
                        percent: 40
                    }, wait: {
                        name:  'Meshing',
                        percent: 60
                    }, save: {
                        name:  'Receiving Mesh',
                        percent: 80
                    },
                }
            }, feasibility: {
                startPosition: 0,
                startLabel: 'Sending Request',
                data: {
                    wait: {
                        name:  'Waiting for Service',
                        percent: 25
                    }, load: {
                        name:  'Simulation',
                        percent: 50
                    }, save: {
                        name:  'Receiving Results',
                        percent: 75
                    }
                }
            }, nest: {
                startPosition: 0,
                startLabel: 'Sending Request',
                data: {
                    wait: {
                        name:  'Waiting for Service',
                        percent: 25
                    }, load: {
                        name:  'Nesting',
                        percent: 50
                    }, save: {
                        name:  'Receiving Results',
                        percent: 75
                    }
                }
            }, blank: {
                startPosition: 0,
                startLabel: 'Sending Request',
                data: {
                  wait: {
                    name:  'Waiting for Service',
                    percent: 25
                  }, load: {
                    name:  'Blanking',
                    percent: 50
                  }, save: {
                    name:  'Receiving Results',
                    percent: 75
                  }
                }
            },report: {
                startPosition: 0,
                startLabel: 'Sending data',
                data: {
                    assemble: {
                        name:  'Assembling response images',
                        percent: 15
                    }, read: {
                        name:  'Assembling report images',
                        percent: 30
                    }, upload: {
                        name:  'Waiting for Service',
                        percent: 45
                    }, wait: {
                        name:  'Waiting for Service',
                        percent: 60
                    }, send: {
                        name:  'Sending email',
                        percent: 75
                    }, save: {
                        name:  'Sending email',
                        percent: 90
                    }
                }
            }, Invalidating: {
                  startPosition: 15,
                  startLabel: 'Invalidating',
            }, clear: {
                startPosition: 15,
                startLabel: 'Clearing session',
            }, ping: {
                startPosition: 15,
                startLabel: 'Continuing session',
            }
        };

        $scope.$on('solverStarted', (event, key) => {
            this.showProgressBar = true;
            const data = this.progressMapper[key];
            this.progress = data.startPosition || 0;
            this.processName = data.startLabel || 'Processing';
        });

        $scope.$on('progressUpdated', (event, data) => {
            if (data.key === 'Finished') {
                this.showProgressBar = false;
                this.processName = undefined;
            } else {
                const info = this.progressMapper[data.step].data[data.key];
                this.progress = info.percent;
                this.processName = info.name
            }
        });

        $scope.$on('solverFinished', () => {
            this.showProgressBar = false;
            this.processName = undefined;
        });
    }
}

SolverProgressController.$inject = ['$scope',];

export default SolverProgressController;



// WEBPACK FOOTER //
// ./client/app/common/solver-progress/solver-progress.controller.js